import { Box, Divider, Spinner, Text, VStack } from "@chakra-ui/react";
import { Card } from "@components/ui-kit";
import { Trans } from "@lingui/macro";
import { observer } from "mobx-react-lite";
import { Fragment } from "react";
import { useStore } from "../../store";
import { GeneralInfo } from "./GeneralInfo";
import { Info } from "./Info";
import { PaymentInfo } from "./PaymentInfo";
import { TotalAmount } from "./TotalAmount";
import { VatItems } from "./VatItems";

export const ExpenseDataCard = observer(function ExpenseDataCard() {
  const store = useStore();

  return (
    <Card>
      {store.predictionFormFillInProgress ? (
        <VStack align="center" justify="center" gap="4" h="700px">
          <Spinner color="teal.500" size="xl" thickness="3px" />
          <Text fontSize="large">
            <Trans>Extracting data, please wait...</Trans>
          </Text>
        </VStack>
      ) : (
        <Fragment>
          <GeneralInfo />
          <Box w="full" px="6">
            <Divider />
          </Box>
          <VatItems />
          <TotalAmount />
          <Box w="full" px="6">
            <Divider />
          </Box>
          <Info />
          <PaymentInfo />
        </Fragment>
      )}
    </Card>
  );
});
